export const COOKIE_JWT_TOKEN_SIMAC = 'JWT-TOKEN-SIMAC';
